import React from "react";
import { observer } from "mobx-react";
import CallsUtils from "Utils/CallsUtils";
import DateUtils from "Utils/DateUtils";
import ConstantObj from "Static/constant";

const getFormattedDate = (createTs = "") => {
  if (!createTs) return "--";
  const d = new Date(createTs);
  return `${ConstantObj?.months?.[d.getMonth()]} ${d.getDate()}, ${d.getFullYear()}`;
};

const CallListItem = observer(({ call = {}, selected = false, onClick }) => {
  const {
    contactName = "",
    memberName = "",
    outcome = "",
    createTs = "",
    duration = 0,
    recordingUrl = "",
    toNumber = ""
  } = call;

  const formattedDuration = CallsUtils.secondsToTime(duration);
  const formattedDate = getFormattedDate(createTs);

  return (
    <div
      className={`callListItem${selected ? " callListItemSelected" : ""}`}
      onClick={onClick}
    >
      <div className="callListItemTop">
        <div className="callListItemInfo">
          <span className="callListItemName">{contactName || toNumber || "--"}</span>
          <span className="callListItemCalledBy">{memberName || "--"}</span>
        </div>
        <span className={`callListItemOutcome callListItemOutcome${(outcome || "").replace(/\b\w/g, c => c.toUpperCase()).replace(/\s+/g, "")}`}>
          {outcome || "--"}
        </span>
      </div>
      <div className="callListItemMeta">
        <span className="callListItemDate">{formattedDate}</span>
        <span className="callListItemDot">·</span>
        <span className="callListItemDuration">{formattedDuration}</span>
        {recordingUrl && (
          <span className="callListItemRecBadge">
            <i className="material-icons">play_circle_outline</i>
            Rec
          </span>
        )}
      </div>
    </div>
  );
});

export default CallListItem;
